module.exports = __webpack_public_path__ + "static/img/nullData.19895f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/nullData.png
// module id = 1Vab
// module chunks = 128